import React from 'react'
import NewsForm from './NewsForm';
import NewsItem from './NewsItem';
import { withAuthorization } from '../session';
import Loader from 'react-loader-spinner';
import Modal from 'react-modal';
import modalStyle from '../styles/modal';
import EmptyList from '../useful/EmptyList';


Modal.setAppElement('#root');
class News extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            itemToEdit: null,
            news: [],
            error: {
                isShow: false,
                message: ''
            }
        }
    }

    componentDidMount() {
        this.setState({ loading: true });
        this.listenNews();
    }

    componentWillUnmount() {
        this.props.firebase.news().off();
    }

    listenNews = () => {
        this.props.firebase.news().off();
        this.props.firebase.news().on('value', (snapshot) => {
            const newsObject = snapshot.val();
            let newsList = [];
            if (newsObject) {
                newsList = Object.keys(newsObject).map(key => ({
                    ...newsObject[key],
                    uid: key,
                }));
            }
            this.setState({
                news: newsList.reverse(),
                loading: false,
            });

        });
    }

    handleSubmit = (item) => {

        if (!item.uid) {
            this.props.firebase.news().push({
                title: item.title,
                url: item.url,
                createdAt: this.props.firebase.timestamp()
            }).then(() => {
                // do nothing
            }).catch(error => {
                this.showErrorModal("Los sentimos, no se pudo crear la noticia.");
                console.log(error);
            });
        } else {
            this.props.firebase
                .newsItem(item.uid)
                .set({
                    title: item.title,
                    url: item.url,
                })
                .then(() => {
                    // do nothing
                })
                .catch(error => {
                    this.showErrorModal("Los sentimos, no se pudo actualizar la noticia.");
                    console.log(error);
                });

        }
        this.setState({
            itemToEdit: null
        })
    }

    handleDelete = (item) => {
        const itemUid = item.uid;

        this.props.firebase.newsItem(itemUid).remove()
            .then(() => {
                // do nothing
            })
            .catch(error => {
                this.showErrorModal("Los sentimos, no se pudo eliminar la noticia.");
                console.log(error);
            });

    }

    handleEdit = (item) => {
        this.setState({
            itemToEdit: item
        });
    }

    showErrorModal = (message) => {
        this.setState({
            error: {
                isShow: true,
                message: message
            }
        });
    }

    closeErrorModal = () => {
        this.setState({
            error: {
                isShow: false,
                message: ''
            }
        });
    }

    render() {

        const { itemToEdit, news, loading, error } = this.state;

        const formKey = itemToEdit ? Math.round(Math.random() * 100) : 0;
        const time = new Date().getTime();
        const newsList = news.length > 0 ?
            news.map((item, i) => {
                return (
                    <NewsItem key={item.uid + time}
                        newsItem={item}
                        index={i}
                        handleDelete={this.handleDelete}
                        handleEdit={this.handleEdit} />
                )
            }) :
            <tr>
                <td colSpan="10">
                    <EmptyList />
                </td>
            </tr>

        return (
            <div>
                <NewsForm key={formKey} itemToEdit={itemToEdit} handleSubmit={this.handleSubmit} />

                <div >
                    <h5>Listado de noticias</h5>

                    {(!loading) ?
                        <div className="table-responsive-md">
                            <table className="table table-sm ">
                                <thead className="thead-dark">
                                    <tr>
                                        {/* <th className="pr-2 pl-2" scope="col">#</th> */}
                                        <th className="pr-2 pl-2" scope="col">Título</th>
                                        <th className="pr-2 pl-2" scope="col">Url</th>
                                        <th className="pr-2 pl-2 text-right" scope="col">Opciones</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: '0.9em' }}>
                                    {newsList}
                                </tbody>
                            </table>
                        </div>
                        :
                        <div className="nav justify-content-center row">
                            <Loader className="mt-4"
                                type="ThreeDots"
                                color="#263238"
                                height={60}
                                width={60}
                                timeout={0} />
                        </div>
                    }

                </div>

                <Modal
                    isOpen={error.isShow}
                    contentLabel="Modal Example"
                    style={modalStyle}
                    onRequestClose={this.closeErrorModal}>
                    <div className="" style={{ minWidth: '300px', maxWidth: '400px' }}>
                        <h5 className="card-title">Error</h5>
                        <p className="card-text text-break">{error.message}</p>

                        <div className="nav justify-content-end">
                            <button onClick={this.closeErrorModal} className="btn btn-sm btn-dark">Cerrar</button>
                        </div>
                    </div>

                </Modal>
            </div>
        );
    }
}

const condition = authUser => !!authUser;
export default withAuthorization(condition)(News);